import React from 'react';
import { Menu, Dropdown } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import ClientType from 'constants/clientType';

import styles from './style.module.scss';

const LanguageSwitcher = () => {
  const { locale } = useSelector(state => state.settings);

  const dispatch = useDispatch();

  const changeLanguage = ({ key }) => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'locale',
        value: key,
      },
    });
  };

  const language = locale.substr(0, 2);

  const menu = (
    <Menu selectedKeys={[locale]} onClick={changeLanguage}>
      {process.env.REACT_APP_CLIENT === ClientType.KS && (
        <Menu.Item key='al-AL'>
          <span className='text-uppercase font-size-12 mr-2'>AL</span>
          Shqip
        </Menu.Item>
      )}
      <Menu.Item key='en-US'>
        <span className='text-uppercase font-size-12 mr-2'>EN</span>
        English
      </Menu.Item>
      {/* <Menu.Item key='mk-MK'>
        <span className='text-uppercase font-size-12 mr-2'>MK</span>
        Македонски
      </Menu.Item> */}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement='bottomRight'>
      <div className={styles.dropdown}>
        <span className='text-uppercase'>{language}</span>
      </div>
    </Dropdown>
  );
};

export default LanguageSwitcher;
